module.exports = __webpack_public_path__ + "media/newstyle/images/icon-image-upload-62cbb1b5e7c0248ea125093d6d28e4cf.svg";